module.exports = __webpack_public_path__ + "img/yuan1.6a4e11ad.png";